import "./Text.scss";

interface Props {
  text: string;
  className?: string;
  fontFamily?: "Poppins" | "Trivial";
  primary?: boolean;
}

export const Text = ({
  text,
  className = "",
  fontFamily,
  primary = false,
}: Props) => {
  return (
    <p
      className={`text ${primary ? "text--primary" : ""} ${className}`}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
};
